import {
    UPDATE_REGISTER_USER_REQUEST,
    UPDATE_REGISTER_USER_SUCCESS,
    UPDATE_REGISTER_USER_FAILED,
    RESET_REGISTER_USER
} from '../../actions/register-flow/register-contact-info'

const initialState = {
    data: null,
    requesting: false,
    error: null
}

export const registerContactInfo = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_REGISTER_USER_REQUEST:
            return Object.assign({}, state, {
                requesting: true,
                data: null,
                error: null,
                completed: false,
            })
        case UPDATE_REGISTER_USER_SUCCESS:
            return Object.assign({}, state, {
                data: action.payload.data.payload,
                requesting: false,
                error: action.error,
                completed: true,
            })
        case UPDATE_REGISTER_USER_FAILED:
            return Object.assign({}, state, {
                data: null,
                requesting: false,
                error: action.error,
                completed: false,
            })
        case RESET_REGISTER_USER:
            return initialState
        default:
            return state
    }

}



// WEBPACK FOOTER //
// ./src/redux/reducers/register-flow/register-contact-info.js